/* eslint-disable */
const CheckmarkIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M12.1831 6.63644L7.52444 11.2951C7.17689 11.6427 6.61333 11.6427 6.26667 11.2951L3.80533 8.83378C3.45867 8.48622 3.45867 7.92356 3.80533 7.57689C4.15289 7.22933 4.71556 7.22933 5.06222 7.57689L6.896 9.40978L10.9262 5.37867C11.2738 5.03111 11.8356 5.03111 12.1831 5.37867C12.5307 5.72622 12.5307 6.28889 12.1831 6.63644ZM8 0C3.58133 0 0 3.58133 0 8C0 12.4187 3.58133 16 8 16C12.4187 16 16 12.4187 16 8C16 3.58133 12.4187 0 8 0Z" />
  </svg>

)

export default CheckmarkIcon